<template>
    <BApp>
        <VersionChecker>
            <RouterView />
        </VersionChecker>
    </BApp>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/authStore';
import { useCountStore } from '@/stores/countStore';
import { useOrganisationStore } from '@/stores/organisationStore';
import { useNotificationStore } from '@/stores/notificationStore';
import VersionChecker from '@/components/VersionChecker.vue';
import { watch } from 'vue';
import { echo } from '@laravel/echo-vue';
const authStore = useAuthStore();
const countStore = useCountStore();
const organisationStore = useOrganisationStore();
const notificationStore = useNotificationStore();

watch(
    () => authStore.loggedIn,
    (isLoggedIn) => {
        if (isLoggedIn) {
            countStore.fetchAllCounts();
        }
    },
    { immediate: true },
);

watch(
    () => organisationStore.current_organisation?.id,
    (newId, oldId) => {
        const echoInstance = echo();

        if (oldId) {
            echoInstance.leave(`organisation.${oldId}`);
        }

        if (newId) {
            notificationStore.fetchOrganisationNotifications(organisationStore.current_organisation);

            echoInstance.private(`organisation.${newId}`).listen('OrganisationNotificationCreated', () => {
                notificationStore.fetchOrganisationNotifications(organisationStore.current_organisation);
            });
        }
    },
    { immediate: true },
);
</script>

<style lang="scss"></style>
